// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import Vuetify from 'vuetify';
import VueRouter from 'vue-router';
import LoadScript from 'vue-plugin-load-script';

import MercuryGlobal from '../../plugins/MercuryGlobal'
import MercuryVueChart from '../../plugins/MercuryVueChart'

import 'jstree';
import 'jstree/dist/themes/default/style.min.css';

import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/dist/vuetify.min.css'
import 'sweetalert2/dist/sweetalert2.min.css';
import 'toastr/toastr.scss';
import 'formulize/dist/formulize.css';

import VueDateRangePicker from 'vue-date-range-picker';

import Sortable from 'vue-sortable'
import {xAjax, API_HOST, clearAuthorization, ERROR_PAGE, menuToRoutes, excludeMenuByGroup} from "../../plugins/MercuryBaseLib";
import baseStore from "../../store/baseStore";
import platformStore from "../../store/platformStore";
import Router from "vue-router";
import i18n from "../../locales/i18n";


Vue.use(LoadScript);
Vue.use(Sortable);
Vue.use(VueDateRangePicker);
Vue.use(Vuex);
Vue.use(Vuetify);
Vue.use(Router)
Vue.use(MercuryVueChart);
Vue.use(MercuryGlobal);

Vue.config.productionTip = false;

const projectName = "Discovery";
const initBaseData = {};
const initPlatformData = {};

(async function () {
  xAjax({
    url: '/base/users/me'
  }).then(async resp => {
    initBaseData['user'] = resp;

    const loadScriptArr = [
      Vue.loadScript(API_HOST + `/base/codes/scripts/${resp.clientId}`)//필수
    ];
    await Promise.all(loadScriptArr)

    if(resp.roles.includes('SYSTEM_MANAGER')){
      const [clients, models] = await Promise.all([
        xAjax({url: '/clientsAll'}),
        xAjax({url: '/main/analysis/reports/columns'})
      ])

      initBaseData['clients'] = clients;
      initPlatformData['models'] = models;
    } else {
      const [clients] = await Promise.all([
        // 서버에서 사용자 체크해서 일반 고객이면 해당 고객의 정보만 내려줌.
        xAjax({url: '/clientsAll'}),
      ])
      initBaseData['clients'] = clients;
    }

    return xAjax({url: '/base/menu/getMenuList', usePrefixUrl: true, data: {menuId: projectName}})
  }).then(resp => {
    const menus = resp;
    const routes = [{
      name: projectName,
      label: projectName,
      path: '/',
      component: () => import(`../../views/main/MpMain`),
      meta: {
        title: projectName
      }
    }];

    menuToRoutes(menus, routes);

    const profileMenu = [];
    if(initBaseData['user'].roles.includes('SYSTEM_MANAGER')){
      profileMenu.push({
        title:'Admin Page',
        icon:'mdi-shield-lock mdi-18px',
        click : function(){
          location.href='/admin.html'
        }
      })
    }

    /* eslint-disable no-new */
    new Vue({
      el: '#app',
      i18n,
      router: new VueRouter({
        // mode: 'history',
        routes
      }),
      store: new Vuex.Store({
        modules: {// 네임스페이스:store
          base: baseStore,
          platform: platformStore
        },
        strict: true // 전역
      }),
      vuetify: new Vuetify(),
      created() {
        this.$store.dispatch('base/initStore', initBaseData);
        this.$store.dispatch('platform/initStore', initPlatformData);
      },
      watch: {
        $route: {
          immediate: true,
          handler(to) {
            if (to !== undefined) {
              document.title = to.meta.title || projectName;
            }
          }
        }
      },
      render: h => h(App, {
        props: {
          templateMenus: menus,
          logo: {
            src: '/static/image/logo.png',
            title: ' Discovery',
            width: 25,
            height: 20
          },
          profile:{
            env: process.env.NODE_ENV === 'production' ? 'PROD' : 'DEV' ,
            name: initBaseData['user'].nickname,
            menuList: profileMenu
          }
        }
      })
    }).$mount('#app');
  }).catch(e=>{
    console.log(e)
    clearAuthorization();
    location.href=ERROR_PAGE
  });
})()


